import { rootApi } from '../rootApi';

/**
 * LMS Eğitim Ön Koşulları — `/v1.0/LmsTrainingPrecondition`.
 * Bkz. docs/LMS-Egitim-Katalogu-ve-Egitmenler-API 2.md §7.
 *
 * Bir eğitime birden fazla ön koşul seçilebilir. `Update` ucu gönderilen `preconditionIds`
 * listesini eğitimin son durumu olarak kabul eder: listede olmayan mevcut satırlar pasife
 * çekilir, yeni seçilenler eklenir — ekrandaki "kaydet" butonu bu uca bağlanmalıdır (doc §7.5).
 */
export const lmsTrainingPreconditionApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getLmsTrainingPreconditions: builder.query({
            query: ({ trainingId, trainingCode, preconditionId, isActive, pageNumber, pageSize }) => ({
                url: 'v1/LmsTrainingPrecondition/GetList',
                method: 'POST',
                body: {
                    trainingId: trainingId ?? null,
                    trainingCode: trainingCode || null,
                    preconditionId: preconditionId ?? null,
                    isActive: isActive !== undefined ? isActive : null,
                    pageNumber: pageNumber || 1,
                    pageSize: pageSize || 10
                }
            }),
            transformResponse: (response) => {
                if (response && response.data && Array.isArray(response.data.items)) {
                    return { items: response.data.items, totalCount: response.data.totalCount || 0 };
                }
                return { items: [], totalCount: 0 };
            },
            providesTags: ['LmsTrainingPrecondition']
        }),

        getLmsTrainingPreconditionById: builder.query({
            query: (id) => ({
                url: 'v1/LmsTrainingPrecondition/GetById',
                method: 'GET',
                params: { id }
            }),
            transformResponse: (response) => response?.data || null,
            providesTags: ['LmsTrainingPrecondition']
        }),

        addLmsTrainingPrecondition: builder.mutation({
            query: ({ trainingId, preconditionIds }) => ({
                url: 'v1/LmsTrainingPrecondition/Add',
                method: 'POST',
                body: { trainingId, preconditionIds }
            }),
            invalidatesTags: ['LmsTrainingPrecondition']
        }),

        // Seçili `preconditionIds` listesinin tamamını gönderir — son durumu temsil eder (doc §7.5)
        updateLmsTrainingPreconditions: builder.mutation({
            query: ({ trainingId, preconditionIds }) => ({
                url: 'v1/LmsTrainingPrecondition/Update',
                method: 'POST',
                body: { trainingId, preconditionIds }
            }),
            invalidatesTags: ['LmsTrainingPrecondition']
        }),

        // Route parametresi eşleşme satırının id'sidir (ön koşul tanımının id'si değil) — doc §7.6
        deleteLmsTrainingPrecondition: builder.mutation({
            query: (id) => ({
                url: `v1/LmsTrainingPrecondition/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['LmsTrainingPrecondition']
        })
    }),
    overrideExisting: false
});

export const {
    useGetLmsTrainingPreconditionsQuery,
    useGetLmsTrainingPreconditionByIdQuery,
    useAddLmsTrainingPreconditionMutation,
    useUpdateLmsTrainingPreconditionsMutation,
    useDeleteLmsTrainingPreconditionMutation
} = lmsTrainingPreconditionApi;
